var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 212,
    viewBox: "0 0 190 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.599 84.8945H81.7773V89.0937H115.525C120.047 89.0937 123.986 91.4608 126.071 94.9645C125.329 89.284 120.483 84.8945 114.599 84.8945Z",
    fill: "url(#paint0_linear_464_30392)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6442 44.7139H75.5641C69.6811 44.7139 64.8332 49.1046 64.0918 54.7851C66.1773 51.282 70.1153 48.9143 74.6388 48.9143H88.6449V44.7139H88.6442Z",
    fill: "url(#paint1_linear_464_30392)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.599 44.7139H92.8438V48.9143H115.524C120.046 48.9143 123.985 51.282 126.07 54.7845C125.328 49.1039 120.483 44.7139 114.599 44.7139Z",
    fill: "url(#paint2_linear_464_30392)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 120.549H132.343V124.749H172.03C176.552 124.749 180.49 127.116 182.577 130.619C181.835 124.938 176.988 120.549 171.104 120.549Z",
    fill: "url(#paint3_linear_464_30392)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.103 59.2568H132.342V63.4566H172.029C176.551 63.4566 180.489 65.8244 182.576 69.3275C181.834 63.6469 176.987 59.2568 171.103 59.2568Z",
    fill: "url(#paint4_linear_464_30392)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.103 80.3682H132.342V84.5673H172.029C176.551 84.5673 180.489 86.9344 182.576 90.4388C181.834 84.7582 176.987 80.3682 171.103 80.3682Z",
    fill: "url(#paint5_linear_464_30392)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.103 100.459H132.342V104.657H172.029C176.551 104.657 180.489 107.027 182.576 110.53C181.834 104.848 176.987 100.459 171.103 100.459Z",
    fill: "#D6E0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.9 69.8115H132.343V74.0113H150.9V69.8115Z",
    fill: "url(#paint6_linear_464_30392)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 69.8115H155.101V74.0113H172.03C176.552 74.0113 180.49 76.3797 182.577 79.8834C181.835 74.2016 176.988 69.8115 171.104 69.8115Z",
    fill: "url(#paint7_linear_464_30392)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.961 90.4131H132.343V94.6129H137.961V90.4131Z",
    fill: "url(#paint8_linear_464_30392)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 90.4131H142.161V94.6129H172.03C176.552 94.6129 180.49 96.9806 182.577 100.483C181.835 94.8032 176.988 90.4131 171.104 90.4131Z",
    fill: "url(#paint9_linear_464_30392)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.459 110.502H132.342V114.703H157.459V110.502Z",
    fill: "url(#paint10_linear_464_30392)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.103 110.502H161.659V114.703H172.029C176.552 114.703 180.489 117.07 182.576 120.574C181.834 114.894 176.987 110.502 171.103 110.502Z",
    fill: "url(#paint11_linear_464_30392)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.961 130.594H132.343V134.793H137.961V130.594Z",
    fill: "url(#paint12_linear_464_30392)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 130.594H142.161V134.793H172.03C176.552 134.793 180.49 137.162 182.577 140.665C181.835 134.984 176.988 130.594 171.104 130.594Z",
    fill: "#D6E0FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M171.103 48.7012H144.558V52.9016H172.03C176.552 52.9016 180.49 55.2687 182.577 58.7718C181.834 53.0912 176.987 48.7012 171.103 48.7012Z",
    fill: "#D6E0FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.359 48.7012H132.342V52.9016H140.359V48.7012Z",
    fill: "url(#paint13_linear_464_30392)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4451 125.073H75.5641C69.6811 125.073 64.8332 129.464 64.0918 135.144C66.1773 131.641 70.1153 129.272 74.6388 129.272H84.4457L84.4451 125.073Z",
    fill: "#D6E0FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.599 125.073H88.6445V129.272H115.525C120.047 129.272 123.986 131.64 126.071 135.144C125.329 129.463 120.483 125.073 114.599 125.073Z",
    fill: "#D6E0FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.109 104.983H75.5641C69.6811 104.983 64.8332 109.374 64.0918 115.055C66.1773 111.552 70.1153 109.184 74.6388 109.184H100.109V104.983Z",
    fill: "url(#paint14_linear_464_30392)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.6 104.983H104.309V109.184H115.525C120.048 109.184 123.986 111.551 126.072 115.054C125.329 109.373 120.484 104.983 114.6 104.983Z",
    fill: "url(#paint15_linear_464_30392)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114.599 64.8027H108.338V69.0019H115.525C120.047 69.0019 123.986 71.3709 126.071 74.8734C125.329 69.1928 120.483 64.8027 114.599 64.8027Z",
    fill: "url(#paint16_linear_464_30392)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104.137 64.8027H75.5641C69.6811 64.8027 64.8332 69.1934 64.0918 74.8747C66.1773 71.3709 70.1153 69.0019 74.6388 69.0019H104.137V64.8027Z",
    fill: "url(#paint17_linear_464_30392)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M114.599 24.1123H81.4375V28.3127H115.525C120.047 28.3127 123.986 30.6792 126.071 34.183C125.329 28.5024 120.483 24.1123 114.599 24.1123Z",
    fill: "url(#paint18_linear_464_30392)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M98.008 13.5566H75.5641C69.6811 13.5566 64.8332 17.9473 64.0918 23.6279C66.1773 20.1248 70.1153 17.7564 74.6388 17.7564H98.0086V13.5566H98.008Z",
    fill: "url(#paint19_linear_464_30392)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M114.599 13.5566H102.208V17.7564H115.524C120.047 17.7564 123.985 20.1235 126.071 23.6273C125.328 17.9467 120.483 13.5566 114.599 13.5566Z",
    fill: "url(#paint20_linear_464_30392)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 130.593H169.795V134.792H172.03C176.552 134.792 180.49 137.161 182.577 140.664C181.835 134.983 176.988 130.593 171.104 130.593Z",
    fill: "url(#paint21_linear_464_30392)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6388 119.23H115.525C120.047 119.23 123.986 121.597 126.071 125.1C125.329 119.419 120.483 115.029 114.599 115.029H75.5641C69.6811 115.029 64.8332 119.421 64.0918 125.101C66.1773 121.597 70.1153 119.23 74.6388 119.23Z",
    fill: "url(#paint22_linear_464_30392)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6388 99.1376H115.525C120.047 99.1376 123.986 101.505 126.071 105.009C125.329 99.3285 120.483 94.9385 114.599 94.9385H75.5641C69.6811 94.9385 64.8332 99.3292 64.0918 105.009C66.1773 101.507 70.1153 99.1376 74.6388 99.1376Z",
    fill: "#D6E0FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6388 79.0481H115.525C120.047 79.0481 123.986 81.4158 126.071 84.9189C125.329 79.2377 120.483 74.8477 114.599 74.8477H75.5641C69.6811 74.8477 64.8332 79.2384 64.0918 84.9189C66.1773 81.4158 70.1153 79.0481 74.6388 79.0481Z",
    fill: "url(#paint23_linear_464_30392)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6388 58.9592H115.525C120.047 58.9592 123.986 61.3257 126.071 64.8294C125.329 59.1488 120.483 54.7588 114.599 54.7588H75.5641C69.6811 54.7588 64.8332 59.1495 64.0918 64.8301C66.1773 61.3263 70.1153 58.9592 74.6388 58.9592Z",
    fill: "url(#paint24_linear_464_30392)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6388 38.8665H115.525C120.047 38.8665 123.986 41.2349 126.071 44.7386C125.329 39.058 120.483 34.668 114.599 34.668H75.5641C69.6811 34.668 64.8332 39.0593 64.0918 44.7392C66.1773 41.2355 70.1153 38.8665 74.6388 38.8665Z",
    fill: "#D6E0FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6388 7.2004H115.525C120.047 7.2004 123.986 9.56817 126.071 13.0706C125.329 7.39006 120.483 3 114.599 3H75.5641C69.6811 3 64.8332 7.39069 64.0918 13.0713C66.1773 9.5688 70.1153 7.2004 74.6388 7.2004Z",
    fill: "#D6E0FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 84.8945H113.291V89.0937H115.524C120.046 89.0937 123.985 91.4608 126.07 94.9645C125.328 89.284 120.482 84.8945 114.598 84.8945Z",
    fill: "url(#paint25_linear_464_30392)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 3H113.291V7.2004H115.524C120.046 7.2004 123.985 9.56817 126.07 13.0706C125.328 7.39006 120.482 3 114.598 3Z",
    fill: "url(#paint26_linear_464_30392)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 94.9385H113.291V99.137H115.524C120.046 99.137 123.985 101.505 126.07 105.008C125.328 99.3285 120.482 94.9385 114.598 94.9385Z",
    fill: "url(#paint27_linear_464_30392)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M126.07 125.1C125.328 119.419 120.482 115.029 114.598 115.029H113.291V119.229H115.524C120.046 119.23 123.985 121.597 126.07 125.1Z",
    fill: "url(#paint28_linear_464_30392)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 104.983H113.291V109.184H115.524C120.046 109.184 123.985 111.551 126.07 115.054C125.328 109.373 120.482 104.983 114.598 104.983Z",
    fill: "url(#paint29_linear_464_30392)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 64.8027H113.291V69.0019H115.524C120.046 69.0019 123.985 71.3709 126.07 74.8734C125.328 69.1928 120.482 64.8027 114.598 64.8027Z",
    fill: "url(#paint30_linear_464_30392)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 74.8477H113.291V79.0481H115.524C120.046 79.0481 123.985 81.4158 126.07 84.9189C125.328 79.2377 120.482 74.8477 114.598 74.8477Z",
    fill: "url(#paint31_linear_464_30392)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 24.1123H113.291V28.3127H115.524C120.046 28.3127 123.985 30.6792 126.07 34.183C125.328 28.5024 120.482 24.1123 114.598 24.1123Z",
    fill: "url(#paint32_linear_464_30392)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 13.5566H113.291V17.7564H115.524C120.046 17.7564 123.985 20.1235 126.07 23.6273C125.328 17.9467 120.482 13.5566 114.598 13.5566Z",
    fill: "url(#paint33_linear_464_30392)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M126.07 135.144C125.328 129.463 120.482 125.073 114.598 125.073H113.291V129.272H115.524C120.046 129.272 123.985 131.64 126.07 135.144Z",
    fill: "url(#paint34_linear_464_30392)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 54.7588H113.291V58.9592H115.524C120.046 58.9592 123.985 61.3257 126.07 64.8294C125.328 59.1488 120.482 54.7588 114.598 54.7588Z",
    fill: "url(#paint35_linear_464_30392)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 44.7129H113.291V48.9133H115.524C120.046 48.9133 123.985 51.2811 126.07 54.7835C125.328 49.103 120.482 44.7129 114.598 44.7129Z",
    fill: "url(#paint36_linear_464_30392)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 34.668H113.291V38.8671H115.524C120.046 38.8671 123.985 41.2355 126.07 44.7392C125.328 39.058 120.482 34.668 114.598 34.668Z",
    fill: "url(#paint37_linear_464_30392)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 84.8945H76.8725V89.0937H74.6382C70.1159 89.0937 66.178 91.4608 64.0918 94.9645C64.8338 89.284 69.6811 84.8945 75.5641 84.8945Z",
    fill: "url(#paint38_linear_464_30392)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 3H76.8725V7.2004H74.6382C70.1159 7.2004 66.178 9.56817 64.0918 13.0706C64.8338 7.39006 69.6811 3 75.5641 3Z",
    fill: "url(#paint39_linear_464_30392)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 94.9385H76.8725V99.137H74.6382C70.1159 99.137 66.178 101.505 64.0918 105.008C64.8338 99.3285 69.6811 94.9385 75.5641 94.9385Z",
    fill: "url(#paint40_linear_464_30392)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0918 125.1C64.8338 119.419 69.6811 115.029 75.5641 115.029H76.8725V119.229H74.6382C70.1159 119.23 66.178 121.597 64.0918 125.1Z",
    fill: "url(#paint41_linear_464_30392)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 104.983H76.8725V109.184H74.6382C70.1159 109.184 66.178 111.551 64.0918 115.054C64.8338 109.373 69.6811 104.983 75.5641 104.983Z",
    fill: "url(#paint42_linear_464_30392)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 64.8027H76.8725V69.0019H74.6382C70.1159 69.0019 66.178 71.3709 64.0918 74.8734C64.8338 69.1928 69.6811 64.8027 75.5641 64.8027Z",
    fill: "url(#paint43_linear_464_30392)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 74.8477H76.8725V79.0481H74.6382C70.1159 79.0481 66.178 81.4158 64.0918 84.9189C64.8338 79.2377 69.6811 74.8477 75.5641 74.8477Z",
    fill: "url(#paint44_linear_464_30392)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 24.1123H76.8725V28.3127H74.6382C70.1159 28.3127 66.178 30.6792 64.0918 34.183C64.8338 28.5024 69.6811 24.1123 75.5641 24.1123Z",
    fill: "url(#paint45_linear_464_30392)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 13.5566H76.8725V17.7564H74.6382C70.1159 17.7564 66.178 20.1235 64.0918 23.6273C64.8338 17.9467 69.6811 13.5566 75.5641 13.5566Z",
    fill: "url(#paint46_linear_464_30392)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0918 135.144C64.8338 129.463 69.6811 125.073 75.5641 125.073H76.8725V129.272H74.6382C70.1159 129.272 66.178 131.64 64.0918 135.144Z",
    fill: "url(#paint47_linear_464_30392)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 54.7588H76.8725V58.9592H74.6382C70.1159 58.9592 66.178 61.3257 64.0918 64.8294C64.8338 59.1488 69.6811 54.7588 75.5641 54.7588Z",
    fill: "url(#paint48_linear_464_30392)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 44.7129H76.8725V48.9133H74.6382C70.1159 48.9133 66.178 51.2811 64.0918 54.7835C64.8338 49.103 69.6811 44.7129 75.5641 44.7129Z",
    fill: "url(#paint49_linear_464_30392)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5641 34.668H76.8725V38.8671H74.6382C70.1159 38.8671 66.178 41.2355 64.0918 44.7392C64.8338 39.058 69.6811 34.668 75.5641 34.668Z",
    fill: "url(#paint50_linear_464_30392)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 48.7012H169.795V52.9016H172.03C176.552 52.9016 180.49 55.2687 182.577 58.7718C181.835 53.0912 176.988 48.7012 171.104 48.7012Z",
    fill: "url(#paint51_linear_464_30392)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 110.502H169.795V114.703H172.03C176.552 114.703 180.49 117.07 182.577 120.574C181.835 114.894 176.988 110.502 171.104 110.502Z",
    fill: "url(#paint52_linear_464_30392)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 120.549H169.795V124.749H172.03C176.552 124.749 180.49 127.116 182.577 130.619C181.835 124.938 176.988 120.549 171.104 120.549Z",
    fill: "url(#paint53_linear_464_30392)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 69.8115H169.795V74.0113H172.03C176.552 74.0113 180.49 76.3797 182.577 79.8834C181.835 74.2016 176.988 69.8115 171.104 69.8115Z",
    fill: "url(#paint54_linear_464_30392)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 59.2568H169.795V63.4566H172.03C176.552 63.4566 180.49 65.8244 182.577 69.3275C181.835 63.6469 176.988 59.2568 171.104 59.2568Z",
    fill: "url(#paint55_linear_464_30392)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 100.459H169.795V104.657H172.03C176.552 104.657 180.49 107.027 182.577 110.53C181.835 104.848 176.988 100.459 171.104 100.459Z",
    fill: "url(#paint56_linear_464_30392)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 90.4131H169.795V94.6129H172.03C176.552 94.6129 180.49 96.9806 182.577 100.483C181.835 94.8032 176.988 90.4131 171.104 90.4131Z",
    fill: "url(#paint57_linear_464_30392)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 80.3682H169.795V84.5673H172.03C176.552 84.5673 180.49 86.9344 182.577 90.4388C181.835 84.7582 176.988 80.3682 171.104 80.3682Z",
    fill: "url(#paint58_linear_464_30392)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2338 72.9902H17.5457C13.0235 72.9902 9.08488 75.3579 7 78.8623C7.74136 73.1804 12.5886 68.791 18.4723 68.791H57.2338V72.9902Z",
    fill: "#D6E0FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 100.459H57.2338V104.657H17.5457C13.0235 104.657 9.08488 107.027 7 110.53C7.74136 104.848 12.5886 100.459 18.4723 100.459Z",
    fill: "#D6E0FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 120.549H57.2338V124.749H17.5457C13.0235 124.749 9.08488 127.116 7 130.619C7.74136 124.938 12.5886 120.549 18.4723 120.549Z",
    fill: "#D6E0FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2341 89.9033H49.2324V94.1037H57.2341V89.9033Z",
    fill: "url(#paint59_linear_464_30392)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 89.9033H45.031V94.1037H17.5457C13.0235 94.1037 9.08488 96.4702 7 99.9733C7.74136 94.2934 12.5886 89.9033 18.4723 89.9033Z",
    fill: "url(#paint60_linear_464_30392)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2341 79.3467H34.2168V83.5464H57.2341V79.3467Z",
    fill: "url(#paint61_linear_464_30392)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 79.3467H30.0173V83.5464H17.5457C13.0235 83.5464 9.08488 85.9142 7 89.4167C7.74136 83.7361 12.5886 79.3467 18.4723 79.3467Z",
    fill: "url(#paint62_linear_464_30392)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2341 110.502H34.2168V114.703H57.2341V110.502Z",
    fill: "url(#paint63_linear_464_30392)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 110.502H30.0173V114.703H17.5457C13.0235 114.703 9.08488 117.07 7 120.574C7.74136 114.894 12.5886 110.502 18.4723 110.502Z",
    fill: "url(#paint64_linear_464_30392)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2341 130.594H49.2324V134.793H57.2341V130.594Z",
    fill: "url(#paint65_linear_464_30392)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 130.594H45.031V134.793H17.5457C13.0235 134.793 9.08488 137.162 7 140.665C7.74136 134.984 12.5886 130.594 18.4723 130.594Z",
    fill: "url(#paint66_linear_464_30392)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 68.791H19.7813V72.9902H17.5457C13.0235 72.9902 9.08488 75.3579 7 78.8623C7.74136 73.1811 12.5886 68.791 18.4723 68.791Z",
    fill: "url(#paint67_linear_464_30392)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 130.593H19.7813V134.792H17.5457C13.0235 134.792 9.08488 137.161 7 140.664C7.74136 134.983 12.5886 130.593 18.4723 130.593Z",
    fill: "url(#paint68_linear_464_30392)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 89.9033H19.7813V94.1037H17.5457C13.0235 94.1037 9.08488 96.4702 7 99.9733C7.74136 94.2934 12.5886 89.9033 18.4723 89.9033Z",
    fill: "url(#paint69_linear_464_30392)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 79.3467H19.7813V83.5464H17.5457C13.0235 83.5464 9.08488 85.9142 7 89.4167C7.74136 83.7361 12.5886 79.3467 18.4723 79.3467Z",
    fill: "url(#paint70_linear_464_30392)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 120.549H19.7813V124.749H17.5457C13.0235 124.749 9.08488 127.116 7 130.619C7.74136 124.938 12.5886 120.549 18.4723 120.549Z",
    fill: "url(#paint71_linear_464_30392)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 110.502H19.7813V114.703H17.5457C13.0235 114.703 9.08488 117.07 7 120.574C7.74136 114.894 12.5886 110.502 18.4723 110.502Z",
    fill: "url(#paint72_linear_464_30392)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 100.459H19.7813V104.657H17.5457C13.0235 104.657 9.08488 107.027 7 110.53C7.74136 104.848 12.5886 100.459 18.4723 100.459Z",
    fill: "url(#paint73_linear_464_30392)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8669 189.951V160.551H26.2309C29.9269 160.551 32.6989 161.251 34.5469 162.651C36.4229 164.051 37.3609 165.899 37.3609 168.195C37.3609 169.735 36.9829 171.079 36.2269 172.227C35.4709 173.347 34.4349 174.215 33.1189 174.831C31.8029 175.447 30.2909 175.755 28.5829 175.755L29.3809 174.033C31.2289 174.033 32.8669 174.341 34.2949 174.957C35.7229 175.545 36.8289 176.427 37.6129 177.603C38.4249 178.779 38.8309 180.221 38.8309 181.929C38.8309 184.449 37.8369 186.423 35.8489 187.851C33.8609 189.251 30.9349 189.951 27.0709 189.951H11.8669ZM18.6289 184.827H26.5669C28.3309 184.827 29.6609 184.547 30.5569 183.987C31.4809 183.399 31.9429 182.475 31.9429 181.215C31.9429 179.983 31.4809 179.073 30.5569 178.485C29.6609 177.869 28.3309 177.561 26.5669 177.561H18.1249V172.605H25.3909C27.0429 172.605 28.3029 172.325 29.1709 171.765C30.0669 171.177 30.5149 170.295 30.5149 169.119C30.5149 167.971 30.0669 167.117 29.1709 166.557C28.3029 165.969 27.0429 165.675 25.3909 165.675H18.6289V184.827ZM44.8221 189.951V160.551H57.5481C60.1801 160.551 62.4481 160.985 64.3521 161.853C66.2561 162.693 67.7261 163.911 68.7621 165.507C69.7981 167.103 70.3161 169.007 70.3161 171.219C70.3161 173.403 69.7981 175.293 68.7621 176.889C67.7261 178.457 66.2561 179.661 64.3521 180.501C62.4481 181.341 60.1801 181.761 57.5481 181.761H48.6021L51.6261 178.779V189.951H44.8221ZM63.5121 189.951L56.1621 179.283H63.4281L70.8621 189.951H63.5121ZM51.6261 179.535L48.6021 176.343H57.1701C59.2701 176.343 60.8381 175.895 61.8741 174.999C62.9101 174.075 63.4281 172.815 63.4281 171.219C63.4281 169.595 62.9101 168.335 61.8741 167.439C60.8381 166.543 59.2701 166.095 57.1701 166.095H48.6021L51.6261 162.861V179.535ZM72.6829 189.951L85.7869 160.551H92.5069L105.653 189.951H98.5129L87.7609 163.995H90.4489L79.6549 189.951H72.6829ZM79.2349 183.651L81.0409 178.485H96.1609L98.0089 183.651H79.2349ZM116.763 189.951L104.079 160.551H111.429L122.517 186.591H118.191L129.447 160.551H136.209L123.483 189.951H116.763ZM139.504 189.951V160.551H146.308V189.951H139.504ZM150.765 189.951L163.407 172.521V177.477L151.311 160.551H159.039L167.397 172.353L164.163 172.395L172.395 160.551H179.787L167.775 177.183V172.311L180.501 189.951H172.647L163.995 177.477H167.103L158.577 189.951H150.765Z",
    fill: "url(#paint74_linear_464_30392)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5073 208.675C20.8335 208.675 20.2125 208.57 19.6442 208.359C19.0841 208.14 18.593 207.831 18.1709 207.433C17.7568 207.036 17.4321 206.569 17.1967 206.033C16.9694 205.497 16.8558 204.909 16.8558 204.267C16.8558 203.626 16.9694 203.038 17.1967 202.502C17.4321 201.966 17.7609 201.499 18.183 201.101C18.6052 200.704 19.1003 200.399 19.6686 200.188C20.2368 199.969 20.8619 199.859 21.5438 199.859C22.2988 199.859 22.9766 199.985 23.5774 200.237C24.1862 200.489 24.6976 200.854 25.1116 201.333L23.8452 202.502C23.5368 202.177 23.1999 201.938 22.8346 201.783C22.4693 201.621 22.0715 201.54 21.6412 201.54C21.2272 201.54 20.8497 201.605 20.5088 201.735C20.1678 201.865 19.8715 202.051 19.6199 202.295C19.3764 202.538 19.1856 202.826 19.0476 203.159C18.9177 203.492 18.8528 203.862 18.8528 204.267C18.8528 204.665 18.9177 205.03 19.0476 205.363C19.1856 205.696 19.3764 205.988 19.6199 206.24C19.8715 206.484 20.1638 206.67 20.4966 206.8C20.8376 206.93 21.211 206.995 21.6169 206.995C22.0065 206.995 22.384 206.934 22.7493 206.812C23.1228 206.682 23.484 206.467 23.8331 206.167L24.9533 207.592C24.4906 207.941 23.9508 208.209 23.3338 208.395C22.725 208.582 22.1161 208.675 21.5073 208.675ZM23.1512 207.336V204.133H24.9533V207.592L23.1512 207.336ZM54.0618 208.529V200.006H57.7514C58.5145 200.006 59.172 200.131 59.724 200.383C60.276 200.627 60.7022 200.98 61.0026 201.442C61.303 201.905 61.4531 202.457 61.4531 203.098C61.4531 203.732 61.303 204.28 61.0026 204.742C60.7022 205.197 60.276 205.546 59.724 205.79C59.172 206.033 58.5145 206.155 57.7514 206.155H55.1577L56.0345 205.29V208.529H54.0618ZM59.4805 208.529L57.3495 205.436H59.4561L61.6114 208.529H59.4805ZM56.0345 205.509L55.1577 204.584H57.6418C58.2506 204.584 58.7052 204.454 59.0056 204.194C59.306 203.926 59.4561 203.561 59.4561 203.098C59.4561 202.628 59.306 202.262 59.0056 202.003C58.7052 201.743 58.2506 201.613 57.6418 201.613H55.1577L56.0345 200.675V205.509ZM94.4322 208.675C93.7584 208.675 93.1333 208.566 92.557 208.347C91.9887 208.127 91.4935 207.819 91.0714 207.421C90.6574 207.023 90.3327 206.557 90.0973 206.021C89.87 205.485 89.7563 204.901 89.7563 204.267C89.7563 203.634 89.87 203.05 90.0973 202.514C90.3327 201.978 90.6615 201.511 91.0836 201.114C91.5057 200.716 92.0009 200.407 92.5692 200.188C93.1374 199.969 93.7544 199.859 94.42 199.859C95.0938 199.859 95.7108 199.969 96.2709 200.188C96.8392 200.407 97.3303 200.716 97.7443 201.114C98.1664 201.511 98.4952 201.978 98.7306 202.514C98.966 203.042 99.0838 203.626 99.0838 204.267C99.0838 204.901 98.966 205.489 98.7306 206.033C98.4952 206.569 98.1664 207.036 97.7443 207.433C97.3303 207.823 96.8392 208.127 96.2709 208.347C95.7108 208.566 95.0979 208.675 94.4322 208.675ZM94.42 206.995C94.8016 206.995 95.1506 206.93 95.4672 206.8C95.792 206.67 96.0761 206.484 96.3196 206.24C96.5632 205.997 96.7499 205.708 96.8797 205.376C97.0178 205.043 97.0868 204.673 97.0868 204.267C97.0868 203.862 97.0178 203.492 96.8797 203.159C96.7499 202.826 96.5632 202.538 96.3196 202.295C96.0842 202.051 95.8041 201.865 95.4794 201.735C95.1547 201.605 94.8016 201.54 94.42 201.54C94.0385 201.54 93.6854 201.605 93.3606 201.735C93.0441 201.865 92.764 202.051 92.5204 202.295C92.2769 202.538 92.0861 202.826 91.9481 203.159C91.8183 203.492 91.7533 203.862 91.7533 204.267C91.7533 204.665 91.8183 205.035 91.9481 205.376C92.0861 205.708 92.2729 205.997 92.5083 206.24C92.7518 206.484 93.0359 206.67 93.3606 206.8C93.6854 206.93 94.0385 206.995 94.42 206.995ZM131.629 208.675C130.42 208.675 129.474 208.339 128.792 207.665C128.11 206.991 127.769 206.029 127.769 204.779V200.006H129.742V204.706C129.742 205.518 129.908 206.102 130.241 206.459C130.574 206.816 131.041 206.995 131.641 206.995C132.242 206.995 132.709 206.816 133.042 206.459C133.375 206.102 133.541 205.518 133.541 204.706V200.006H135.489V204.779C135.489 206.029 135.148 206.991 134.467 207.665C133.785 208.339 132.839 208.675 131.629 208.675ZM164.715 208.529V200.006H168.404C169.167 200.006 169.825 200.131 170.377 200.383C170.929 200.627 171.355 200.98 171.656 201.442C171.956 201.905 172.106 202.457 172.106 203.098C172.106 203.732 171.956 204.28 171.656 204.742C171.355 205.205 170.929 205.562 170.377 205.814C169.825 206.057 169.167 206.179 168.404 206.179H165.811L166.687 205.29V208.529H164.715ZM166.687 205.509L165.811 204.572H168.295C168.904 204.572 169.358 204.442 169.659 204.182C169.959 203.922 170.109 203.561 170.109 203.098C170.109 202.628 169.959 202.262 169.659 202.003C169.358 201.743 168.904 201.613 168.295 201.613H165.811L166.687 200.675V205.509Z",
    fill: "#041038"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_464_30392",
    x1: 93.5783,
    y1: 88.472,
    x2: 126.28,
    y2: 96.2819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_464_30392",
    x1: 70.6333,
    y1: 48.2918,
    x2: 89.4646,
    y2: 50.7844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_464_30392",
    x1: 101.696,
    y1: 48.2916,
    x2: 126.82,
    y2: 52.7922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_464_30392",
    x1: 145.726,
    y1: 124.126,
    x2: 182.25,
    y2: 134.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_464_30392",
    x1: 145.725,
    y1: 62.8346,
    x2: 182.249,
    y2: 72.7264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_464_30392",
    x1: 145.725,
    y1: 83.9459,
    x2: 182.249,
    y2: 93.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_464_30392",
    x1: 137.287,
    y1: 71.3035,
    x2: 150.981,
    y2: 74.5887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_464_30392",
    x1: 162.421,
    y1: 73.3897,
    x2: 183.403,
    y2: 76.4975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_464_30392",
    x1: 133.84,
    y1: 91.9051,
    x2: 138.201,
    y2: 92.2219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_464_30392",
    x1: 152.929,
    y1: 93.9906,
    x2: 183.04,
    y2: 100.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_464_30392",
    x1: 139.034,
    y1: 111.994,
    x2: 156.766,
    y2: 117.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_464_30392",
    x1: 167.232,
    y1: 114.08,
    x2: 183.351,
    y2: 115.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_464_30392",
    x1: 133.84,
    y1: 132.086,
    x2: 138.201,
    y2: 132.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_464_30392",
    x1: 134.478,
    y1: 50.1934,
    x2: 140.668,
    y2: 50.8349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_464_30392",
    x1: 73.6876,
    y1: 108.562,
    x2: 100.774,
    y2: 113.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_464_30392",
    x1: 110.107,
    y1: 108.561,
    x2: 126.86,
    y2: 110.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_464_30392",
    x1: 113.062,
    y1: 68.3805,
    x2: 126.776,
    y2: 69.6916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_464_30392",
    x1: 74.7609,
    y1: 68.3809,
    x2: 104.621,
    y2: 74.8269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_464_30392",
    x1: 93.329,
    y1: 27.69,
    x2: 126.255,
    y2: 35.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_464_30392",
    x1: 73.128,
    y1: 17.1346,
    x2: 98.7405,
    y2: 21.8177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_464_30392",
    x1: 108.566,
    y1: 17.1344,
    x2: 126.885,
    y2: 19.4912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_464_30392",
    x1: 173.2,
    y1: 134.171,
    x2: 183.128,
    y2: 134.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_464_30392",
    x1: 80.6045,
    y1: 118.607,
    x2: 124.116,
    y2: 133.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_464_30392",
    x1: 80.6045,
    y1: 78.4256,
    x2: 124.116,
    y2: 92.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_464_30392",
    x1: 80.6045,
    y1: 58.3367,
    x2: 124.116,
    y2: 72.8751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_464_30392",
    x1: 116.696,
    y1: 88.472,
    x2: 126.622,
    y2: 89.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_464_30392",
    x1: 116.696,
    y1: 6.57773,
    x2: 126.622,
    y2: 7.2616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_464_30392",
    x1: 116.696,
    y1: 98.516,
    x2: 126.622,
    y2: 99.1999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_464_30392",
    x1: 116.696,
    y1: 118.607,
    x2: 126.622,
    y2: 119.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_464_30392",
    x1: 116.696,
    y1: 108.561,
    x2: 126.622,
    y2: 109.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_464_30392",
    x1: 116.696,
    y1: 68.3805,
    x2: 126.622,
    y2: 69.0643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_464_30392",
    x1: 116.696,
    y1: 78.4256,
    x2: 126.622,
    y2: 79.1094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_464_30392",
    x1: 116.696,
    y1: 27.69,
    x2: 126.622,
    y2: 28.3739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_464_30392",
    x1: 116.696,
    y1: 17.1344,
    x2: 126.622,
    y2: 17.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_464_30392",
    x1: 116.696,
    y1: 128.651,
    x2: 126.622,
    y2: 129.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_464_30392",
    x1: 116.696,
    y1: 58.3365,
    x2: 126.622,
    y2: 59.0204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_464_30392",
    x1: 116.696,
    y1: 48.2906,
    x2: 126.622,
    y2: 48.9745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_464_30392",
    x1: 116.696,
    y1: 38.2459,
    x2: 126.622,
    y2: 38.9298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_464_30392",
    x1: 67.4969,
    y1: 88.472,
    x2: 77.4238,
    y2: 89.1561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_464_30392",
    x1: 67.4969,
    y1: 6.57773,
    x2: 77.4238,
    y2: 7.26174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_464_30392",
    x1: 67.4969,
    y1: 98.516,
    x2: 77.4238,
    y2: 99.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_464_30392",
    x1: 67.4969,
    y1: 118.607,
    x2: 77.4238,
    y2: 119.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_464_30392",
    x1: 67.4969,
    y1: 108.561,
    x2: 77.4238,
    y2: 109.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_464_30392",
    x1: 67.4969,
    y1: 68.3805,
    x2: 77.4238,
    y2: 69.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_464_30392",
    x1: 67.4969,
    y1: 78.4256,
    x2: 77.4238,
    y2: 79.1096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_464_30392",
    x1: 67.4969,
    y1: 27.69,
    x2: 77.4238,
    y2: 28.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_464_30392",
    x1: 67.4969,
    y1: 17.1344,
    x2: 77.4238,
    y2: 17.8184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_464_30392",
    x1: 67.4969,
    y1: 128.651,
    x2: 77.4238,
    y2: 129.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_464_30392",
    x1: 67.4969,
    y1: 58.3365,
    x2: 77.4238,
    y2: 59.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_464_30392",
    x1: 67.4969,
    y1: 48.2906,
    x2: 77.4238,
    y2: 48.9746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_464_30392",
    x1: 67.4969,
    y1: 38.2459,
    x2: 77.4238,
    y2: 38.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_464_30392",
    x1: 173.2,
    y1: 52.2789,
    x2: 183.128,
    y2: 52.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_464_30392",
    x1: 173.2,
    y1: 114.08,
    x2: 183.128,
    y2: 114.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_464_30392",
    x1: 173.2,
    y1: 124.126,
    x2: 183.128,
    y2: 124.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_464_30392",
    x1: 173.2,
    y1: 73.3897,
    x2: 183.128,
    y2: 74.0738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_464_30392",
    x1: 173.2,
    y1: 62.8346,
    x2: 183.128,
    y2: 63.5187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_464_30392",
    x1: 173.2,
    y1: 104.037,
    x2: 183.128,
    y2: 104.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_464_30392",
    x1: 173.2,
    y1: 93.9906,
    x2: 183.128,
    y2: 94.6748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_464_30392",
    x1: 173.2,
    y1: 83.9459,
    x2: 183.128,
    y2: 84.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_464_30392",
    x1: 51.3643,
    y1: 91.3956,
    x2: 57.5427,
    y2: 92.0346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_464_30392",
    x1: 17.1324,
    y1: 93.4808,
    x2: 45.6142,
    y2: 99.3211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_464_30392",
    x1: 40.3491,
    y1: 80.8387,
    x2: 56.8507,
    y2: 85.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_464_30392",
    x1: 13.1324,
    y1: 82.9242,
    x2: 30.8226,
    y2: 85.1196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_464_30392",
    x1: 40.3491,
    y1: 111.994,
    x2: 56.8515,
    y2: 116.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_464_30392",
    x1: 13.1324,
    y1: 114.08,
    x2: 30.8227,
    y2: 116.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_464_30392",
    x1: 51.3643,
    y1: 132.086,
    x2: 57.5427,
    y2: 132.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_464_30392",
    x1: 17.1324,
    y1: 134.172,
    x2: 45.6145,
    y2: 140.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_464_30392",
    x1: 10.4052,
    y1: 72.369,
    x2: 20.3326,
    y2: 73.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_464_30392",
    x1: 10.4052,
    y1: 134.171,
    x2: 20.3326,
    y2: 134.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_464_30392",
    x1: 10.4052,
    y1: 93.4808,
    x2: 20.3326,
    y2: 94.1649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_464_30392",
    x1: 10.4052,
    y1: 82.9242,
    x2: 20.3326,
    y2: 83.6083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_464_30392",
    x1: 10.4052,
    y1: 124.126,
    x2: 20.3326,
    y2: 124.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_464_30392",
    x1: 10.4052,
    y1: 114.08,
    x2: 20.3326,
    y2: 114.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_464_30392",
    x1: 10.4052,
    y1: 104.037,
    x2: 20.3326,
    y2: 104.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_464_30392",
    x1: 94.8809,
    y1: 169.796,
    x2: 94.8809,
    y2: 191.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01030F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/LogoDark.9d9031782d259e273c82bc9737b68525.svg";
export { ForwardRef as ReactComponent };